import React from 'react';
import PropTypes from 'prop-types';

const SorryNotFound = ({
  style = {},
  fill = '',
  width = '100%',
  height = '100%',
  className = '',
  viewBox = '0 0 88 88',
  fillRule = 'evenodd',
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    fillRule={fillRule}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      d="M44 0c24.3 0 44 19.7 44 44S68.3 88 44 88 0 68.3 0 44 19.7 0 44 0zm0 4C21.909 4 4 21.909 4 44s17.909 40 40 40 40-17.909 40-40S66.091 4 44 4zm-.008 46c9.71 0 18.349 5.82 22.09 14.6.432 1.017-.04 2.192-1.057 2.625-1.016.432-2.19-.04-2.624-1.057C59.284 58.85 52.085 54 43.992 54c-7.885 0-14.933 4.604-18.175 11.642-.463 1.003-1.65 1.442-2.654.98-1.003-.462-1.442-1.65-.98-2.654C26.073 55.525 34.531 50 43.993 50zM28 28c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm34 0c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4z"
    />
  </svg>
);

SorryNotFound.propTypes = {
  style: PropTypes.object,
  fill: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  className: PropTypes.string,
  viewBox: PropTypes.string,
  fillRule: PropTypes.string,
};

export default SorryNotFound;
